export { default } from "./useStudentQuizGet";
